import apiClient from '../apiClient';
import { GET_CUSTOM_ENUM_BY_CATAGORIES } from '../apiUrl';

const getCustomEnumByCatagoriesRevenueRangeApi = () => {
  return apiClient.get(GET_CUSTOM_ENUM_BY_CATAGORIES('REVENUE_RANGE'));
};

export default getCustomEnumByCatagoriesRevenueRangeApi;
